import FAQContent from "../component/FAQContent"

function PatientDocumentationView() {

    return (
        <div className={"p-8"}>
            <FAQContent display={"patient"} />
        </div>
    )
}

export default PatientDocumentationView